module.exports = __webpack_public_path__ + "img/performance-tiao-icon1.4edd9d72.png";